import { IEvent } from '@studyportals/event-aggregation-service-interface';
import { InlineSearchCommands } from '../enums';

export class InlineSearchAppClearInput implements IEvent {
	public static readonly EventType = InlineSearchCommands.INLINE_SEARCH_APP_CLEAR_INPUT_EVENT;

	public readonly timestamp = new Date();
	public readonly eventType = InlineSearchAppClearInput.EventType;


	public static is(event: IEvent): event is InlineSearchAppClearInput {
		return event.eventType === InlineSearchAppClearInput.EventType as string;
	}
}